module.exports = __webpack_public_path__ + "img/doc.e3b3011d.png";